<script setup lang="ts">
import PreviewZone from './PreviewZone.vue'
import type { Audience } from '@/types/types'

defineProps<{
  audiences: Audience[]
}>()

const { t } = useI18n()

const isEnabled = defineModel<boolean>('isEnabled', { required: true })
const audienceIds = defineModel<number[]>('audienceIds', { required: true })

const hasNoAudience = computed(() => isEnabled.value && audienceIds.value.length === 0)
</script>

<template>
  <PreviewZone zone="loyalty" class="flex flex-col gap-5">
    <h3 class="text-base font-sans font-semibold">
      {{ t('pages.loyaltySupports.webapp.config.customerStatus.title') }}
    </h3>
    <BaseSwitch id="hasCustomerStatus" v-model="isEnabled" class="brick-switch">
      <template #label>
        <span class="flex flex-col">
          <span class="text-sm font-medium text-foreground">
            {{ t('pages.loyaltySupports.webapp.config.customerStatus.label') }}
          </span>
          <span class="text-sm font-normal text-muted-foreground">
            {{ t('pages.loyaltySupports.webapp.config.customerStatus.description') }}
          </span>
        </span>
      </template>
    </BaseSwitch>
    <div v-if="isEnabled" class="flex flex-col gap-1.5">
      <p class="text-sm font-normal text-foreground">
        {{ t('pages.loyaltySupports.webapp.config.customerStatus.audiencesLabel') }}
      </p>
      <MultiSelectAudiences
        v-model="audienceIds"
        :audiences="audiences"
        hide-empty-categories
        :default-text="t('pages.loyaltySupports.webapp.config.customerStatus.placeholder')"
      />
      <p v-if="hasNoAudience" class="text-sm text-destructive">
        {{ t('pages.loyaltySupports.webapp.config.customerStatus.noAudienceError') }}
      </p>
    </div>
  </PreviewZone>
</template>
